// extracted by mini-css-extract-plugin
export default {"cards":"Packages_cards__Byd-t"};